import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-update-templates',
  templateUrl: './update-templates.component.html',
  styleUrls: ['./update-templates.component.css']
})
export class UpdateTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/mail-templates/update-templates/update-templates.component.ts